module.exports = __webpack_public_path__ + "img/roullet_ha.a2c6d5a2.png";